import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import App from './App.vue'
import router from './router'
import store from './store'
import LogRocket from 'logrocket'

Vue.config.productionTip = false;


// set initial testvalues
//function URLSearchParams is not defined in IE11, so we need to implement it ourselves.
(function (w) {

    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    }

})(window);

const urlParams = new URLSearchParams(location.search);
if (urlParams.get("test") === "1") {
  localStorage.removeItem('unizoffscanv3');
  store.commit('setInitialState', {
    sessionId: 'UlArgf2giMYNDdHe5C4Yx',
    userDetails: { "firstName": "B", "lastName": "V", "email": "bv@hotmail.com", "company": "BV", "companyId": "123456", "phone": "123456", "zipCode": "2600", "province": "Antwerpen" },
    progress: 'REGISTRATION_COMPLETED',
    companyTypes: ["algemeen", "maak", "other"],
    companyTypeInput: 'Testing',
    version: 'v1',
    leadfollowupStatus: 'Te contacteren'
  });
}

if (urlParams.get("test") === "2") {
    localStorage.removeItem('unizoffscanv3');
    store.commit('setInitialState', {
      sessionId: 'UlArgf2giMYNDdHe5C4Yx',
      userDetails: { "firstName": "T", "lastName": "T", "email": "t@t.com", "company": "TComp", "companyId": "123456", "phone": "123456", "zipCode": "3000", "province": "Vlaams-Brabant" },
      progress: 'REGISTRATION_COMPLETED',
      companyTypes: ["algemeen", "maak", "other"],
      companyTypeInput: 'Testing',
      version: 'v1',
      leadfollowupStatus: 'Te contacteren'
    });
}

if (urlParams.get("test") === "0") {
    localStorage.removeItem('unizoffscanv3');
    store.commit('setInitialState', {
      sessionId: 'UlArgf2giMYNDdHe5C4Yx',
      userDetails: { "firstName": "T", "lastName": "T", "email": "t@t.com", "company": "TComp", "companyId": "123456", "phone": "123456", "zipCode": "3000", "province": "Vlaams-Brabant" },
      progress: 'STARTED',
      companyTypes: ["algemeen"],
      version: 'v1',
      leadfollowupStatus: 'Te contacteren'
    });
}


Vue.use(Vue2TouchEvents)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (process.env.VUE_APP_MODE === 'production') {
  gtag('config', 'UA-122322212-1', { page_path: router.currentRoute.path })
  LogRocket.init('whighr/unizo-ff-scan')
}

router.afterEach((to, from) => {
  if (process.env.VUE_APP_MODE === 'production') {
    gtag('config', 'UA-122322212-1', { page_path: to.path })
  }
})
